import React from 'react';

import {
	useClassNames,
} from '@common';

import {
	LoaderIcon,
} from '@icons';

import './Spinner.scss';

interface SpinnerProps {
	content?: JSX.Element;
	className?: string;
}

function Spinner(props: SpinnerProps): JSX.Element {
	const {
		className,
		content = <LoaderIcon />,
	} = props;

	const classes = useClassNames(
		'spinner',
		className,
	);

	return (
		<div className={classes}>
			{content}
		</div>
	);
}

const MemoisedSpinner = React.memo(Spinner);

export {MemoisedSpinner as Spinner};